// import { MdOutlineArrowDropDown } from 'react-icons/md';
import { useOSDetection } from '../../hooks/useOSDetection';
import { ISelect } from './interfaces';
import { useEffect, useRef, useState } from 'react';
import { TextInputSkeleton } from '../text-input';
import { useShortcut } from '../../hooks/useShortcut';
import { useClickOutside } from '../../hooks/useClickOutside';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import styles from './select.module.css';

export const Select = ({
	className,
	disabled = false,
	error,
	id,
	isLoading,
	isRequired = true,
	label,
	name,
	onChange,
	options,
	value,
	shortcut,
}: ISelect) => {
	const [openMenu, setOpenMenu] = useState(true);
	const selectRef = useRef<HTMLDivElement>(null!);
	const os = useOSDetection();
	useShortcut(setOpenMenu, shortcut);
	useClickOutside(setOpenMenu, selectRef);

	const renderSelectedText = (): string => {
		if (!value) {
			return 'Selecciona una opción';
		} else {
			const text =
				options.find((option) => value.toString() === option.value)?.label || '';
			return text;
		}
	};

	const toggleValue = (value: string, item: any): void => {
		const event = {
			target: {
				name: name,
				value: value,
			},
		} as React.ChangeEvent<HTMLInputElement>;

		onChange(event, item);
	};

	useEffect(() => {
		setOpenMenu(false);
	}, [value]);

	if (isLoading) return <TextInputSkeleton />;

	return (
		<main className={styles.main} ref={selectRef} id={id}>
			{label && (
				<label htmlFor={id} className={styles.label}>
					{label}
					{isRequired && <span className={styles.required}>*</span>}
				</label>
			)}

			<section
				onClick={() => !disabled && setOpenMenu(!openMenu)}
				className={`${styles.selectBox} ${className || ''}`}
			>
				<span>{renderSelectedText()}</span>

				<div className={styles.shortcutContainer}>
					{shortcut && (
						<>
							<span className={styles.shortcutKey}>
								{os === 'MacOS' ? '⌘' : 'Ctrl'}
							</span>
							<span className={styles.shortcutKey}>
								{shortcut.toUpperCase()}
							</span>
						</>
					)}

					<div
						className={`${styles.iconWrapper} ${
							openMenu ? styles.rotate180 : ''
						}`}
					>
						<ExpandMoreIcon />
					</div>
				</div>
			</section>

			<div
				className={`${styles.dropdown} ${
					openMenu ? styles.dropdownOpen : styles.dropdownClosed
				}`}
			>
				<div className={`${styles.dropdownItem} ${className}`}>
					Selecciona una opción
				</div>
				<div
					className={styles.optionsContainer}
					data-cy="select-options-container"
				>
					{options.map((item) => (
						<div
							key={item.value}
							className={`${styles.option} ${className}`}
							onClick={() => toggleValue(item.value, item)}
							data-cy="select-option"
						>
							{item.label}
						</div>
					))}
				</div>
			</div>

			{error && (
				<span id={`error-msg-${name}`} className={styles.errorMsg}>
					{error}
				</span>
			)}
		</main>
	);
};
